import _Math$trunc from 'babel-runtime/core-js/math/trunc';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { ClosedCaptionIcon } from '../assets/ClosedCaptionIcon';
import { PauseIcon } from '../assets/PauseIcon';
import { PlayIcon } from '../assets/PlayIcon';
import { RewindIcon } from '../assets/RewindIcon';
import { blueActiveColor, blueHoverColor, controlsBlue, controlsDisabled, controlsGrey, controlsLightGrey, darkColor, mediumGrey, veryVeryLightGrey, white } from '../styles/colors';
import { isSmallScreen, isTouchScreen } from '../utils/media-utils';
import { withHover } from '../utils/withHover';
import { withPlayerUpdater } from '../utils/withPlayerUpdater';

export var MEDIA_CONTROLS_HEIGHT = 36;

var CC_BUTTON_SPACE = 42;
var REWIND_BUTTON_SPACE = 40;
var DURATION_DISP_SPACE = 50;

var MediaPlayerControlsDiv = styled.div({
  position: 'relative',
  width: '100%',
  flex: 'none',
  height: MEDIA_CONTROLS_HEIGHT
});

//************************** play/pause button
var PlayPauseBtnDiv = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: MEDIA_CONTROLS_HEIGHT,
    height: MEDIA_CONTROLS_HEIGHT,
    cursor: 'pointer'
  };
  if (props.disabled) {
    style.pointerEvents = 'none';
  }
  return style;
});

var PlayButtonBase = function (_PureComponent) {
  _inherits(PlayButtonBase, _PureComponent);

  function PlayButtonBase() {
    var _temp, _this, _ret;

    _classCallCheck(this, PlayButtonBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _PureComponent.call.apply(_PureComponent, [this].concat(args))), _this), _this.render = function () {
      var playPauseIcon = void 0;
      var iconColor = void 0;
      var circleColor = void 0;
      if (_this.props.showPlay) {
        // play button
        iconColor = white;
        circleColor = controlsBlue;
        if (_this.props.disabled) {
          iconColor = veryVeryLightGrey;
          circleColor = controlsDisabled;
        } else if (!isTouchScreen() && _this.props.hovering) {
          if (_this.props.active) {
            circleColor = blueActiveColor;
          } else {
            circleColor = blueHoverColor;
          }
        }
        playPauseIcon = React.createElement(PlayIcon, { circleColor: circleColor, iconColor: iconColor });
      } else {
        // pause button
        iconColor = controlsBlue;
        circleColor = controlsLightGrey;
        if (_this.props.disabled) {
          circleColor = veryVeryLightGrey;
          iconColor = controlsDisabled;
        } else if (!isTouchScreen() && _this.props.hovering) {
          if (_this.props.active) {
            iconColor = blueActiveColor;
          } else {
            iconColor = blueHoverColor;
          }
        }
        playPauseIcon = React.createElement(PauseIcon, { circleColor: circleColor, iconColor: iconColor });
      }
      return React.createElement(
        PlayPauseBtnDiv,
        { disabled: _this.props.disabled },
        playPauseIcon
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return PlayButtonBase;
}(PureComponent);

var PlayPauseButton = withHover(PlayButtonBase);

//************************** rewind button
var RewindBtnDiv = styled.div(function (props) {
  var style = {
    position: 'absolute',
    right: 0,
    top: 4,
    paddingLeft: 5,
    paddingRight: 1,
    paddingTop: 3,
    paddingBottom: 3,
    width: 28,
    height: 28,
    cursor: 'pointer'
  };
  if (props.disabled) {
    style.pointerEvents = 'none';
  }
  if (props.withDurationDisp) {
    style.right += DURATION_DISP_SPACE;
  }
  return style;
});

var RewindButtonBase = function (_PureComponent2) {
  _inherits(RewindButtonBase, _PureComponent2);

  function RewindButtonBase() {
    var _temp2, _this2, _ret2;

    _classCallCheck(this, RewindButtonBase);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _PureComponent2.call.apply(_PureComponent2, [this].concat(args))), _this2), _this2.render = function () {
      var iconColor = controlsBlue;
      if (_this2.props.disabled) {
        iconColor = controlsDisabled;
      } else if (_this2.props.hovering) {
        if (_this2.props.active) {
          iconColor = blueActiveColor;
        } else {
          iconColor = blueHoverColor;
        }
      }
      return React.createElement(
        RewindBtnDiv,
        {
          'data-qa': 'RewindButton',
          disabled: _this2.props.disabled,
          withDurationDisp: _this2.props.withDurationDisp
        },
        React.createElement(RewindIcon, { fillColor: iconColor })
      );
    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
  }

  return RewindButtonBase;
}(PureComponent);

var RewindButton = withHover(RewindButtonBase);

//************************** closed caption button
var CcButtonDiv = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: MEDIA_CONTROLS_HEIGHT / 2 - 15,
    right: REWIND_BUTTON_SPACE,
    width: 30,
    height: 30,
    cursor: 'pointer'
  };
  if (props.withDurationDisp) {
    style.right += DURATION_DISP_SPACE;
  }

  return style;
});
var CCIconContainer = styled.div(function () {
  return {
    position: 'absolute',
    top: 3,
    left: 3,
    width: 24,
    height: 24
  };
});

var CCButtonBase = function (_PureComponent3) {
  _inherits(CCButtonBase, _PureComponent3);

  function CCButtonBase() {
    var _temp3, _this3, _ret3;

    _classCallCheck(this, CCButtonBase);

    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, _PureComponent3.call.apply(_PureComponent3, [this].concat(args))), _this3), _this3.render = function () {
      var iconColor = mediumGrey;
      if (_this3.props.showingCaptions) {
        iconColor = darkColor;
      } else if (_this3.props.hovering) {
        if (_this3.props.active) {
          iconColor = blueActiveColor;
        } else {
          iconColor = blueHoverColor;
        }
      }
      return React.createElement(
        CcButtonDiv,
        { 'data-qa': 'CCButton' },
        React.createElement(
          CCIconContainer,
          null,
          React.createElement(ClosedCaptionIcon, { fillColor: iconColor })
        )
      );
    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
  }

  return CCButtonBase;
}(PureComponent);

var CCButton = withHover(CCButtonBase);

var THUMB_SIZE = 11;
var SMALL_SCREEN_THUMB_SIZE = 17;
var TRACK_HEIGHT = 3;

var getThumbSize = function getThumbSize() {
  if (isSmallScreen() || isTouchScreen()) {
    return SMALL_SCREEN_THUMB_SIZE;
  }
  return THUMB_SIZE;
};

var SliderBox = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: MEDIA_CONTROLS_HEIGHT / 2 - getThumbSize() / 2,
    left: MEDIA_CONTROLS_HEIGHT + 12,
    right: REWIND_BUTTON_SPACE,
    height: getThumbSize(),
    padding: (getThumbSize() - TRACK_HEIGHT) / 2
  };
  if (props.withCaptionButton) {
    style.right += CC_BUTTON_SPACE;
  }
  if (props.withDurationDisp) {
    style.right += DURATION_DISP_SPACE;
  }
  return style;
});
var ThumbTrack = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  borderRadius: 2,
  backgroundColor: controlsGrey,
  overflow: 'hidden'
});
var ProgressDisplay = styled.div(function (props) {
  var style = {
    position: 'absolute',
    height: '100%',
    left: 0,
    width: props.progressPosition,
    backgroundColor: controlsBlue
  };
  return style;
});
var ClickTrack = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: (getThumbSize() - TRACK_HEIGHT) / 2,
    right: (getThumbSize() - TRACK_HEIGHT) / 2,
    cursor: 'pointer'
  };
  if (props.disabled) {
    style.pointerEvents = 'none';
  }
  return style;
});

var ThumbButton = styled.div(function (props) {
  var style = {
    position: 'absolute',
    top: 0,
    left: props.position,
    width: getThumbSize(),
    height: getThumbSize(),
    cursor: 'pointer',
    backgroundColor: controlsBlue,
    borderRadius: '100%',
    ':hover': {
      backgroundColor: blueHoverColor
    }
  };
  if (props.disabled) {
    style.pointerEvents = 'none';
    style.backgroundColor = controlsDisabled;
  } else if (props.isScrubbing) {
    style[':hover'] = blueActiveColor;
    style.backgroundColor = blueActiveColor;
  }
  // ff is tweaking the thumb for small/touch screen
  //  instead of using backgroundColor,
  //  we use a circle which allows padding outside itself, for a small
  //  appearance but a larger touch area; also, no hover
  if (isSmallScreen() || isTouchScreen()) {
    style.borderRadius = 0;
    style.padding = (SMALL_SCREEN_THUMB_SIZE - THUMB_SIZE) / 2;
    style[':hover'] = {};
    style.backgroundColor = undefined;
    if (props.isScrubbing) {
      style.padding = 0;
    }
  }
  return style;
});

var DurationDisplay = styled.div(function (props) {
  var style = {
    position: 'absolute',
    right: 0,
    top: 10,
    width: DURATION_DISP_SPACE - 10,
    fontSize: 14,
    lineHeight: '18px',
    color: props.textColor,
    textAlign: 'left'
  };
  return style;
});

//***************************************************************************************
// MediaPlayerControls provides user interface for the media-player actions and progress
//

var MediaPlayerControlsBase = function (_PureComponent4) {
  _inherits(MediaPlayerControlsBase, _PureComponent4);

  function MediaPlayerControlsBase(props) {
    _classCallCheck(this, MediaPlayerControlsBase);

    var _this4 = _possibleConstructorReturn(this, _PureComponent4.call(this, props));

    _this4.updateSliderWidth = function () {
      if (_this4.sliderBoxRef.current) {
        var boxNode = _this4.sliderBoxRef.current;
        var sliderWidth = boxNode.getBoundingClientRect().width - getThumbSize();
        _this4.setState({ sliderWidth: sliderWidth });
      }
    };

    _this4.toggleTranscripts = function () {
      var track = _this4.props.mediaPlayer.video.textTracks[0];
      if (track) {
        if (track.mode === 'showing') {
          track.mode = 'hidden';
        } else {
          track.mode = 'showing';
        }
        _this4.setState({
          showingCaptions: track.mode === 'showing'
        });
      }
    };

    _this4.handleResize = function () {
      _this4.updateSliderWidth();
    };

    _this4.thumbXFromPosition = function (newPos) {
      var newX = 0;
      if (_this4.state.sliderWidth !== -1 && !isNaN(_this4.props.mediaDuration) && _this4.props.mediaDuration > 0) {
        newX = _this4.state.sliderWidth * newPos / _this4.props.mediaDuration;
        newX = Math.round(newX);
        newX = Math.max(0, newX);
        newX = Math.min(_this4.state.sliderWidth, newX);
      }
      return newX;
    };

    _this4.mediaTimeFractionFromX = function (newX) {
      var timeFraction = 0;
      if (_this4.state.sliderWidth !== -1) {
        newX = Math.max(0, newX);
        newX = Math.min(_this4.state.sliderWidth, newX);
        timeFraction = newX / _this4.state.sliderWidth;
      }
      return timeFraction;
    };

    _this4.handleRewindClick = function () {
      var rewoundPos = _this4.props.mediaPosition - 10;
      rewoundPos = Math.max(rewoundPos, 0);
      _this4.setState({ scrubbingPos: _this4.thumbXFromPosition(rewoundPos) });
      var rewoundFraction = rewoundPos / _this4.props.mediaDuration;
      rewoundFraction = Math.min(rewoundFraction, 1);
      var wasPlaying = _this4.props.mediaPlayer.isPlaying;
      if (wasPlaying) {
        _this4.props.mediaPlayer.pause();
      }
      _this4.props.mediaPlayer.setTimeAsFraction(rewoundFraction);
      if (wasPlaying) {
        _this4.props.mediaPlayer.play();
      }
    };

    _this4.getThumbPosition = function () {
      if (_this4.state.isScrubbing) {
        return _this4.state.scrubbingPos;
      }
      if (_this4.props.isMediaSeeking) {
        return _this4.state.scrubbingPos;
      }
      return _this4.thumbXFromPosition(_this4.props.mediaPosition);
    };

    _this4.startScrubbing = function (onThumb, mouseOrTouchEvent) {
      document.addEventListener('mouseup', _this4.stopScrubbing);
      document.addEventListener('mousemove', _this4.doScrubbing);
      document.addEventListener('touchend', _this4.stopScrubbing);
      document.addEventListener('touchmove', _this4.doScrubbing);
      var thumbNode = _this4.thumbRef.current;
      var boxNode = _this4.sliderBoxRef.current;
      var mouseOffset = void 0;
      var pointerClientX = mouseOrTouchEvent.changedTouches ? mouseOrTouchEvent.changedTouches[0].clientX : mouseOrTouchEvent.clientX;
      var newThumbLeft = void 0;
      if (onThumb) {
        mouseOffset = pointerClientX - thumbNode.getBoundingClientRect().left;
        newThumbLeft = thumbNode.getBoundingClientRect().left - boxNode.getBoundingClientRect().left;
      } else {
        mouseOffset = thumbNode.getBoundingClientRect().width / 2;
        newThumbLeft = pointerClientX - mouseOffset - boxNode.getBoundingClientRect().left;
        newThumbLeft = Math.max(newThumbLeft, 0);
        newThumbLeft = Math.min(newThumbLeft, _this4.state.sliderWidth);
      }
      _this4.setState({
        wasPlayingBeforeScrub: _this4.props.mediaPlayer.isPlaying,
        scrubberMouseOffset: mouseOffset,
        scrubbingPos: newThumbLeft,
        isScrubbing: true
      });
      _this4.props.mediaPlayer.pause();
    };

    _this4.doScrubbing = function (mouseOrTouchEvent) {
      var boxNode = _this4.sliderBoxRef.current;
      var boxClientRect = boxNode.getBoundingClientRect();
      var pointerClientX = mouseOrTouchEvent.changedTouches ? mouseOrTouchEvent.changedTouches[0].clientX : mouseOrTouchEvent.clientX;
      var newX = pointerClientX - _this4.state.scrubberMouseOffset - boxClientRect.left;
      newX = Math.max(newX, 0);
      newX = Math.min(newX, _this4.state.sliderWidth);
      _this4.setState({ scrubbingPos: newX });
      var positionFraction = _this4.mediaTimeFractionFromX(newX);
      _this4.props.mediaPlayer.setTimeAsFraction(positionFraction);
    };

    _this4.stopScrubbing = function () {
      document.removeEventListener('mouseup', _this4.stopScrubbing);
      document.removeEventListener('mousemove', _this4.doScrubbing);
      document.removeEventListener('touchend', _this4.stopScrubbing);
      document.removeEventListener('touchmove', _this4.doScrubbing);
      var positionFraction = _this4.mediaTimeFractionFromX(_this4.state.scrubbingPos);
      _this4.props.mediaPlayer.setTimeAsFraction(positionFraction);
      if (_this4.state.wasPlayingBeforeScrub) {
        _this4.props.mediaPlayer.play();
      }
      _this4.setState({
        isScrubbing: false
      });
    };

    _this4.handlePlayPauseClicked = function () {
      if (_this4.props.isMediaPlaying) {
        _this4.props.mediaPlayer.pause();
      } else {
        _this4.props.mediaPlayer.play();
      }
    };

    _this4.getPrintableMediaDuration = function () {
      if (!_this4.props.isMediaLoaded) {
        return '';
      }
      var allSeconds = Math.round(_this4.props.mediaDuration);
      var allMinutes = _Math$trunc(allSeconds / 60);
      var hours = _Math$trunc(allMinutes / 60);
      var minutes = allMinutes % 60;
      var seconds = allSeconds % 60;
      var outString = '';
      if (hours > 0) {
        outString += hours + ':';
        if (minutes < 10) {
          outString += '0';
        }
      }
      outString += minutes + ':';
      if (seconds < 10) {
        outString += '0';
      }
      outString += seconds;
      return outString;
    };

    var showing = false;
    if (props.mediaPlayer.video && props.mediaPlayer.video.textTracks.length > 0) {
      showing = props.mediaPlayer.video.textTracks[0].mode === 'showing';
    }
    _this4.state = {
      showingCaptions: showing,
      wasPlayingBeforeScrub: false,
      scrubberMouseOffset: 0,
      sliderWidth: -1,
      scrubbingPos: -1,
      isScrubbing: false
    };
    _this4.sliderBoxRef = React.createRef();
    _this4.thumbRef = React.createRef();
    return _this4;
  }

  MediaPlayerControlsBase.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.updateSliderWidth();
  };

  MediaPlayerControlsBase.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateSliderWidth();
  };

  MediaPlayerControlsBase.prototype.componentWillUnmount = function componentWillUnmount() {
    this.props.mediaPlayer.pause();
    window.removeEventListener('resize', this.handleResize);
  };

  MediaPlayerControlsBase.prototype.render = function render() {
    var _this5 = this;

    var ccButton = null;
    if (this.props.mediaPlayer.video && this.props.mediaPlayer.video.textTracks.length > 0) {
      ccButton = React.createElement(CCButton, { clickHandler: this.toggleTranscripts, showingCaptions: this.state.showingCaptions });
    }

    var durationDisp = void 0;
    if (this.props.withDurationDisp) {
      durationDisp = React.createElement(
        DurationDisplay,
        null,
        this.getPrintableMediaDuration()
      );
    }

    var isDisabled = !this.props.isMediaLoaded || this.props.disabled;

    // ff is tweaking the thumb for small/touch screen
    //  instead of using backgroundColor,
    //  we use a circle which allows padding outside itself, for a small
    //  appearance but a larger touch area
    var innerCircle = void 0;
    if (isSmallScreen() || isTouchScreen()) {
      var thumbColor = controlsBlue;
      if (isDisabled) {
        thumbColor = controlsDisabled;
      }
      innerCircle = React.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg', width: '100%', height: '100%', viewBox: '0 0 1060 1060' },
        React.createElement('circle', { fill: thumbColor, cx: '530', cy: '530', r: '530' })
      );
    }

    return React.createElement(
      MediaPlayerControlsDiv,
      null,
      React.createElement(PlayPauseButton, {
        dataQa: 'PlayButton' + (isDisabled ? '' : '_enabled'),
        disabled: isDisabled,
        showPlay: !this.props.isMediaPlaying,
        clickHandler: this.handlePlayPauseClicked
      }),
      React.createElement(
        SliderBox,
        { ref: this.sliderBoxRef, withCaptionButton: !!ccButton, withDurationDisp: !!durationDisp },
        React.createElement(
          ThumbTrack,
          { 'data-qa': 'ThumbTrack' },
          React.createElement(ProgressDisplay, { progressPosition: this.getThumbPosition() })
        ),
        React.createElement(ClickTrack, {
          disabled: isDisabled,
          onMouseDown: function onMouseDown(evt) {
            _this5.startScrubbing(false, evt);
          },
          onTouchStart: function onTouchStart(evt) {
            _this5.startScrubbing(false, evt);
          }
        }),
        React.createElement(
          ThumbButton,
          {
            'data-qa': 'ThumbButton',
            disabled: isDisabled,
            ref: this.thumbRef,
            onMouseDown: function onMouseDown(evt) {
              _this5.startScrubbing(true, evt);
            },
            onTouchStart: function onTouchStart(evt) {
              _this5.startScrubbing(true, evt);
            },
            isScrubbing: this.state.isScrubbing,
            position: this.getThumbPosition()
          },
          innerCircle
        )
      ),
      ccButton,
      React.createElement(RewindButton, {
        disabled: isDisabled || this.props.mediaPosition < 1,
        clickHandler: this.handleRewindClick,
        withDurationDisp: !!durationDisp
      }),
      durationDisp
    );
  };

  return MediaPlayerControlsBase;
}(PureComponent);

MediaPlayerControlsBase.propTypes = {
  mediaPlayer: PropTypes.object.isRequired,
  withDurationDisp: PropTypes.bool,

  // the ff are from withMediaUpdater
  isMediaSeeking: PropTypes.bool,
  isMediaPlaying: PropTypes.bool,
  // mediaPosition is mediaPlayer.position, which is seconds
  mediaPosition: PropTypes.number,
  // mediaDuration is mediaPlayer.duration, which is seconds
  mediaDuration: PropTypes.number,
  isMediaLoaded: PropTypes.bool
};


export var MediaPlayerControls = withPlayerUpdater(MediaPlayerControlsBase);